import classNames from "classnames";
import PropTypes from "prop-types";
import { BiCog } from "react-icons/bi";

const StepSidePanel = ({
  open,
  title,
  subtitle,
  closeLabel,
  onClose,
  onBody,
  onMeta,
}) => (
  <aside
    className={classNames("canvas-claude canvas-side", {
      "canvas-claude--hidden": !open,
    })}
    aria-label={title}
  >
    <div className="canvas-claude__head">
      <button
        type="button"
        className="canvas-claude__avatar canvas-claude__avatar--button"
        aria-label={closeLabel}
        title={closeLabel}
        aria-expanded={open}
        onClick={onClose}
      >
        <BiCog size={20} />
      </button>
      <div className="canvas-claude__heading">
        <h2 className="canvas-claude__title">{title}</h2>
        <span className="canvas-claude__subtitle canvas-side__subtitle">
          {subtitle ? <span>{subtitle}</span> : null}
          <span ref={onMeta} className="canvas-side__meta-slot" />
        </span>
      </div>
    </div>
    <div ref={onBody} className="canvas-side__body" />
  </aside>
);

StepSidePanel.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  closeLabel: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onBody: PropTypes.func.isRequired,
  onMeta: PropTypes.func,
};

StepSidePanel.defaultProps = {
  open: false,
  subtitle: null,
  onMeta: () => null,
};

export default StepSidePanel;
